import './App.css';
import Whiteboard from './components/Whiteboard';

function App() {
  return (
    <div className="App">
      <main>
        <Whiteboard />
      </main>
    </div>
  );
}

export default App;
